import React from "react";
import { useTranslation } from "react-i18next";
import "./magazine.css";

export default function Heading() {
  const { t } = useTranslation();
  return (
    <section className="avc-page-hero">
      <div className="container avc-page-hero__inner">
        <span className="avc-eyebrow">
          <i className="fas fa-book-open" aria-hidden="true"></i>
          {t("magazine_eyebrow")}
        </span>
        <h1 className="avc-page-hero__title">{t("Legal_Magazine_title")}</h1>
        <p className="avc-page-hero__lead">{t("Legal_Magazine_description")}</p>
      </div>
    </section>
  );
}
